"use client";

import { Bank } from "@alba-cars/common-modules";
import { useEffect } from "react";

import { useBanks } from "@/contexts/BanksContext";

export const BanksHydrator = ({ initialBanks }: { initialBanks: Bank[] }) => {
  const { hydrate } = useBanks();

  useEffect(() => {
    if (Array.isArray(initialBanks) && initialBanks.length > 0) {
      hydrate(initialBanks);
    }
  }, [hydrate, initialBanks]);

  return null;
};
